import Vue from 'vue';
import VueMq from 'vue-mq';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import ScrollNav from '@/plugins/scroll-nav';
import TextAnimations from '@/plugins/text-animations';
import Device from '@/plugins/device';
import 'intersection-observer';
import '@/plugins/filters';
import '@/assets/styles/partials/reset.css';
import '@/assets/fonts/font.css';
import '@/assets/styles/main.scss';

Vue.config.productionTip = false;

const breakpoints = {
  xsm: 360,
  sm: 600,
  tb: 992,
  md: 1200,
  lg: Infinity
};

Vue.use(VueMq, {
  breakpoints,
  defaultBreakpoint: 'sm'
});

Vue.use(Device, { mq: VueMq });

Vue.use(ScrollNav, {
  fullpage: true,
  router,
  device: Device,
  offset: window.innerWidth >= breakpoints.tb ? 0 : -30
});

Vue.use(TextAnimations);

const query = {};
window.location.search
  .substr(1)
  .split('&')
  .forEach(function(item) {
    query[item.split('=')[0]] = item.split('=')[1];
  });

i18n.locale = query.lang || 'it';

Vue.prototype.$config = {
  year: 2021
};

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
